import React from "react";
import _ from "lodash";

import { NO_VALUE_PLACEHOLDER } from "../table/helpers";

export const Manufacturer = ({ className, manufacturer }) => {
  const isManufacturerDefined = () =>
    !_.isEmpty(manufacturer) && !_.isNil(manufacturer);

  return (
    <span className={className}>
      {isManufacturerDefined() ? manufacturer : NO_VALUE_PLACEHOLDER}
    </span>
  );
};
